import { useContext } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { DeviceTypes, RightArrowIcon, useDeviceType } from 'common';
import { GlobalContext } from 'context';
import { Link, Headings, Button, Paragraph } from '@sentara-health/optimahealth_web';

function PayMonthlyPremium() {
  //  Initialize useTranslation hook
  const { t } = useTranslation();
  // Initialize SSO URL hook and feature toggles
  const { ssoEndPoints, getFeature } = useContext(GlobalContext);
  const deviceType = useDeviceType();
  const isMobile = deviceType === DeviceTypes.MOBILE;

  return (
    <>
      <div className="mb-4">
        <Headings
          level={isMobile ? 3 : 2}
          text={t('common.payMonthlyPremiumHeader')}
          variant="semiBold"
          dataTestId="payMonthlyPremiumHeader"
        />
      </div>

      {/* Step 1: Make Your Initial (Binder) Payment */}
      <div className="mb-4">
        <Headings
          level={isMobile ? 4 : 3}
          text={t('common.payMonthlyPremiumStep1')}
          variant="semiBold"
          dataTestId="payMonthlyPremiumStep1"
        />
        <Paragraph
          className="mt-3 mb-3"
          text={t('payMonthlyPremium.payMonthlyPremiumStep1Message1')}
          variant="regular"
          data-testid={'payMonthlyPremiumStep1Message1'}
        />
        <Paragraph
          className="mt-3 mb-3"
          text={t('payMonthlyPremium.payMonthlyPremiumStep1Message2')}
          variant="regular"
          data-testid={'payMonthlyPremiumStep1Message2'}
        />
        <Link
          to={t('payMonthlyPremium.payMonthlyPremiumResourceUrl')}
          target="_blank"
          className="text-decoration-underline"
          dataTestId="binderPaymentLink"
        >
          {t('payMonthlyPremium.payMonthlyPremiumStep1Link')}
        </Link>
      </div>

      {/* Step 2: Schedule Your Monthly Payment */}
      <div className="mb-4">
        <Headings
          level={isMobile ? 4 : 3}
          text={t('common.payMonthlyPremiumStep2')}
          variant="semiBold"
          dataTestId="payMonthlyPremiumStep2"
        />
        <Paragraph
          className="mt-3 mb-3"
          text={t('payMonthlyPremium.payMonthlyPremiumStep2Message')}
          variant="regular"
          data-testid={'payMonthlyPremiumStep2Message'}
        />
        {getFeature?.PayMonthlyPremiumPageNote && (
          <Paragraph
            className="mb-3"
            text={t('payMonthlyPremium.payMonthlyPremiumStep2Note')}
            variant="regular"
            data-testid={'payMonthlyPremiumStep2Note'}
          //showContent={getFeature?.PayMonthlyPremiumPage}
          />
        )}
        <div className="d-flex align-items-center">
          <Button
            dataTestId={'continueNavigate'}
            onClick={() => {
              window.open(ssoEndPoints?.PayMonthlyPremium ?? '', '_blank');
            }}
            iconRight={<RightArrowIcon />}
            variant="link_btn"
             iconStroke="none"
          >
            {t('payMonthlyPremium.payMonthlyPremiumContinueButton')}
          </Button>
        </div>
      </div>
    </>
  );
}

export default PayMonthlyPremium;